module.exports = __webpack_public_path__ + "static/media/Rectangle 114.9b99a1cc.png";